import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  API_URL = environment.API_URL;
  API_URL_BILLING = environment.API_URL_BILLING;
  API_URL_OVERVIEW = environment.API_URL_OVERVIEW;
  API_URL_FLEET = environment.API_URL_FLEET;
  API_URL_CAPTAIN=environment.API_URL_CAPTAIN;
  ACCESS_TOKEN: string;
  headers;
  httpOptions;


  constructor(private http: HttpClient, private storage: StorageService) {
    this.refreshAccessToken();
  }

  refreshAccessToken() {
    this.ACCESS_TOKEN = this.storage.getFromCookie('access_token') + ' Carrier ' + this.storage.getFromCookie('carrier_id');
  }


  get(path: string, params: any = '', urlType = 0) {
    let apiurl;
    if (urlType == 1) {
      apiurl = this.API_URL_BILLING;
    }else if( urlType == 2){
      apiurl = this.API_URL_OVERVIEW;
    }else if( urlType == 3){
      apiurl = this.API_URL_FLEET;
    }else if( urlType == 4){
      apiurl = this.API_URL_CAPTAIN;
    }else{
      apiurl = this.API_URL
    }
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + this.ACCESS_TOKEN
      })
    };
    return this.http.get(apiurl + path, {params: params, headers: this.httpOptions.headers}).pipe(map(
      (res) => res
    ));
  }

  login(path: string, data: any) {
    return this.http.post(this.API_URL + path, data, this.httpOptions).pipe(map(
      (res) => res
    ));
  }

  upload(path: string, data: any,urlType = 0) {
    let apiurl;
    if (urlType == 1) {
      apiurl = this.API_URL_BILLING;
    }else if( urlType == 2){
      apiurl = this.API_URL_OVERVIEW;
    }else if( urlType == 3){
      apiurl = this.API_URL_FLEET;
    }else if( urlType == 4){
      apiurl = this.API_URL_CAPTAIN;
    }else{
      apiurl = this.API_URL
    }
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.ACCESS_TOKEN
      })
    };

    return this.http.post(apiurl + path, data, this.httpOptions).pipe(map(
      (res) => res
    ));
  }

  update(path: string, data: any) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.ACCESS_TOKEN
      })
    };
    return this.http.put(this.API_URL + path, data, this.httpOptions).pipe(map(
      (res) => res
    ));
  }

  put(path: string, data: any = '',urlType = 0) {

    let apiurl;
    if (urlType == 1) {
      apiurl = this.API_URL_BILLING;
    }else if( urlType == 2){
      apiurl = this.API_URL_OVERVIEW;
    }else if( urlType == 3){
      apiurl = this.API_URL_FLEET;
    }else if( urlType == 4){
      apiurl = this.API_URL_CAPTAIN;
    }else{
      apiurl = this.API_URL
    }

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + this.ACCESS_TOKEN
      })
    };

    return this.http.put(apiurl + path, data, this.httpOptions).pipe(map(
      (res) => res
    ));
  }

  post(path: string, data: any, urlType = 0) {
    let apiurl;
    if (urlType == 1) {
      apiurl = this.API_URL_BILLING;
    }else if( urlType == 2){
      apiurl = this.API_URL_OVERVIEW;
    }else if( urlType == 3){
      apiurl = this.API_URL_FLEET;
    }else if( urlType == 4){
      apiurl = this.API_URL_CAPTAIN;
    }else{
      apiurl = this.API_URL
    }
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + this.ACCESS_TOKEN
      })
    };

    return this.http.post(apiurl + path, data, this.httpOptions).pipe(map(
      (res) => res
    ));
  }
  
  delete(path: string, data: any) {
    return this.http.delete(this.API_URL + path, data).pipe(map(
      (res) => res
    ));
  }
  customPost(path: string, data: any) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'bearer ' + this.ACCESS_TOKEN
      })
    };

    return this.http.post(path, data, this.httpOptions).pipe(map(
      (res) => res
    ));
  }
  customGet(path: string, data: any = '') {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'bearer ' + this.ACCESS_TOKEN
      })
    };

    return this.http.get(path, {params: data, headers: this.httpOptions.headers}).pipe(map(
      (res) => res
    ));
  }
}
